import axios from 'axios';

const client = axios.create();

// this interceptor will redirect the user to the login page on any 401 response
client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      window.location = '/logout';
    }
    return Promise.reject(error);
  },
);

export { client };
